import { motion } from "framer-motion"; // For animations
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EXAM_URLS, QUESTIONS_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { LOGIN_LOGO } from "../../services/ImageService";
import { showAlertAutoClose } from "../../services/notifyService";
import { post } from "../../services/smartApiService";
import "./exam.scss";
import { changeDateTimeFormat } from "../../services/core/CommonService";
import moment from "moment";

interface Question {
  id: number;
  question: string;
  options: string[];
  image?: string;
}

const Exam: React.FC = () => {
  const { state } = useLocation();
  const { openModal, closeModal, setTitle, settings } = useSiteContext();
  const navigate = useNavigate();
  const [_data, setData] = useState<any>();
  const [questions, setQuestions] = useState<any[]>([]);
  const [questionsO, setQuestionsO] = useState<any[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState<{ [key: number]: number }>({});
  const [timeLeft, setTimeLeft] = useState(20 * 60); // 20 minutes
  const [startTime, setStartTime] = useState<number | null>(null);
  const [totalMinutes, setTotalMinutes] = useState<number | null>(null);
  const [markedForReview, setMarkedForReview] = useState<Set<number>>(
    new Set()
  );
  const [visitedQuestions, setVisitedQuestions] = useState<number[]>([]);
  const [language, setLanguage] = useState(_data?.language_code); // 'en' or 'hi'
  const [changeLang, setChangeLang] = useState<boolean>(false);

  const updateTimeLeft = (startTime: number, totalMinutes: number) => {
    const currentTime = Math.floor(Date.now() / 1000); // Current Unix timestamp in seconds
    const endTime = startTime + totalMinutes * 60; // End time in seconds
    const remaining = Math.max(0, Math.floor((endTime - currentTime) / 60));
    // console.log("remaining minutes " , remaining);
    setTimeLeft(remaining * 60);
    if (remaining <= 0) {
      submitExam();
    }
  };

  useEffect(() => {
    if (timeLeft === 0) {
      submitExam();
    }
  }, [timeLeft]);

  const lng_type = _data?.language_code === "hi" ? "hi" : "en";

  const labels = {
    employeeId: { en: "Employee ID", hi: "कर्मचारी आईडी" },
    name: { en: "Name", hi: "नाम" },
    sessionId: { en: "Session ID", hi: "सत्र आईडी" },
    date: { en: "Date", hi: "तारीख" },
    questionNavigator: { en: "Questions Navigator", hi: "प्रश्न नेविगेटर" },
    progress: { en: "Progress", hi: "प्रगति" },
    answered: { en: "Answered", hi: "उत्तर दिया गया" },
    examStatistics: { en: "Exam Statistics", hi: "परीक्षा सांख्यिकी" },
    questions: { en: "questions", hi: "प्रश्न" },
    notAnswered: { en: "Not Answered", hi: "उत्तर नहीं दिया गया" },
    notVisited: { en: "Not Visited", hi: "प्रवेश नहीं किया गया" },
    colorLegend: { en: "Color Legend", hi: "रंग संकेत" },
    currentQuestion: { en: "Current Question", hi: "वर्तमान प्रश्न" },
    projectName: { en: "Project Name", hi: "परियोजना का नाम" },
  };

  const loadData = () => {
    let URL = EXAM_URLS.GET_QUESTIONS;
    const subscription = post(URL, {}).subscribe((response) => {
      //console.log("data " , response.data);
      setQuestions(response.data.questions);

      setQuestionsO(response.data.questions_other_lang);
      setData(response.data.session_data);
      setAnswers(response.data.answers);
      updateTimeLeft(
        response.data.session_data.start_time,
        response.data.session_data.time_limit
      );
      setStartTime(response.data.session_data.start_time);
      setTotalMinutes(response.data.session_data.time_limit);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const toggleLangForCurrent = () => {
    setChangeLang((prev) => !prev);
  };
  useEffect(() => {
    setChangeLang(false);
  }, [currentIndex]);

  const load_transited_question = (id: number, language: string) => {
    let URL = EXAM_URLS.GET_TRANSLATED_QUESTION;
    let payload = {
      question_id: id,
      language_code: language,
    };

    const subscription = post(URL, payload).subscribe((response) => {
      const t = response.data;

      setQuestions((prev) =>
        prev.map((q) =>
          q.question_id === id
            ? {
                ...q,
                question_text: t.question_text,
                correct_option: t.correct_option,
                options: t.options.map((opt: any) => ({
                  option_id: opt.id,
                  option_text: opt.option_text,
                })),
              }
            : q
        )
      );
    });

    return () => subscription.unsubscribe();
  };

 

  useEffect(() => {
    if (questions?.length > 0 && questions[currentIndex]) {
      const questionId = questions[currentIndex].question_id;
      load_transited_question(questionId, language);
    }
  }, [language]);
  useEffect(() => {
    loadData();
    // axios.get(`/api/questions?lang=${state.language}`).then((res) => {
    //   setQuestions(res.data);
    // });

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev === 60) showAlertAutoClose("1 minutes remaining!", "error");
        if (prev <= 0) {
          if (_data) {
            submitExam();
            clearInterval(timer);
          }

          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const currentQid = questions[currentIndex]?.question_id;
    if (currentQid && !visitedQuestions.includes(currentQid)) {
      setVisitedQuestions((prev) => [...prev, currentQid]);
    }
  }, [currentIndex, questions]);

  const updateAnswer = (question_id: number, option_id: number) => {
    let URL = EXAM_URLS.OPTION_UPDATE;
    let payload = {
      session_id: _data?.session_id,
      question_id: question_id,
      selected_option_id: option_id,
      is_correct: 0,
    };
    const subscription = post(URL, payload, { showLoading: false }).subscribe(
      (response) => {
        //console.log("data " , response.data);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const handleOptionChange = (id: number, option: number) => {
    setAnswers((prev) => ({ ...prev, [id]: option }));
    updateAnswer(id, option);
  };

  const submit_exam = () => {
    let URL = EXAM_URLS.SUBMIT_EXAM;
    const subscription = post(URL, {}).subscribe((response) => {
      navigate("/exam/results", { state: { language: _data?.language_code } });
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const toggleMarkForReview = (qid: number) => {
    setMarkedForReview((prev) => {
      const updated = new Set(prev);
      updated.has(qid) ? updated.delete(qid) : updated.add(qid);
      return updated;
    });
  };

  const getButtonClass = (q: any, index: number) => {
    if (index === currentIndex) return "is-info question_select";

    if (answers[q.question_id]) return "is-success";
    if (visitedQuestions.includes(q.question_id)) return "is-danger";
    return "is-dark";
  };
  const handleQuestionChange = (index: number) => {
    const questionId = questions[index].question_id;

    setCurrentIndex(index);

    setVisitedQuestions((prev) =>
      prev.includes(questionId) ? prev : [...prev, questionId]
    );
  };

  const examStatusHindi = () => {
    const questions_length = questions.length;
    const answers_length = Object.values(answers).filter(
      (value) => value !== 0
    ).length;
    console.log(answers);
    const rem_count = questions_length - answers_length;
    return (
      <table className="table is-fullwidth">
        <tr>
          <th>कुल प्रश्न</th>
          <td>{questions_length}</td>
        </tr>
        <tr>
          <th>कुल उत्तर दिए गए</th>
          <td>{answers_length}</td>
        </tr>
        <tr>
          <th>कुल अनुत्तरित</th>
          <td className="has-text-danger">
            <b>{rem_count}</b>
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="is-size-7 has-text-link">
            <i>नोट: परीक्षा समाप्त करने के लिए कृपया सबमिट पर क्लिक करें।</i>
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="has-text-centered">
            <button className="button is-success mr-4" onClick={submitExam}>
              Submit
            </button>
          </td>
        </tr>
      </table>
    );
  };

  const examStatus = () => {
    const questions_length = questions.length;
    const answers_length = Object.values(answers).filter(
      (value) => value !== 0
    ).length;
    //console.log("answers",answers);
    const rem_count = questions_length - answers_length;
    return (
      <table className="table is-fullwidth">
        <tr>
          <th>Total Questions</th>
          <td>{questions_length}</td>
        </tr>
        <tr>
          <th>Total Answered</th>
          <td>{answers_length}</td>
        </tr>
        <tr>
          <th>Total UnAttended</th>
          <td className="has-text-danger">
            <b>{rem_count}</b>
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="is-size-7 has-text-link">
            <i>Note: Please click on Submit to Finish the Exam</i>
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="has-text-centered">
            <button className="button is-success mr-4" onClick={submitExam}>
              Submit
            </button>
          </td>
        </tr>
      </table>
    );
  };

  const openStatus = () => {
    let options = {
      title: "Exam Report",
      content: _data.language_code == "en" ? examStatus() : examStatusHindi(),
      className: "sd-efl-modal",
      closeBody: false,
      width: 40,
    };
    openModal(options);
  };

  const submitExam = () => {
    closeModal();
    submit_exam();
  };

  const answeredCount = Object.values(answers).filter(
    (value) => value !== 0
  ).length;
  const notAnsweredCount = Object.values(answers).filter(
    (value) => value === 0
  ).length;

  //console.log("answeredCount",answeredCount);
  const totalQuestions = questions?.length;
  const progressPercent =
    totalQuestions > 0 ? Math.round((answeredCount / totalQuestions) * 100) : 0;

  const openImageModal = (imageContent: any) => {
    const modalObject = {
      title: " Question Image",
      content: (
        <>
          <p className="image">
            <img src={`data:image/png;base64,${imageContent}`} alt="Preview" />
          </p>
        </>
      ),

      className: "sd-efl-modal",
      width: 40,
    };
    openModal(modalObject);
  };

  return (
    <div className="exam-container ">
      <div className="exam-header-container">
        <div className="exam-header-title title has-text-white mt-3">
          {settings?.exam_title}
        </div>
        <div className="header-details-view">
          <div className="header-details-row">
            <div className="header-detail-item is-flex has-text-white has-text-weight-bold has-text-left">
              <strong className="has-text-white">
                {labels.employeeId[lng_type]} :
              </strong>{" "}
              <span className="has-text-warning">{_data?.euserid}</span>
            </div>
            <div className="header-detail-item is-flex has-text-white has-text-weight-bold">
              <strong className="has-text-white">
                {labels?.name[lng_type]}:{" "}
              </strong>{" "}
              <span className="has-text-warning">{_data?.ename}</span>
            </div>
          </div>
          <div className="header-details-row has-text-white has-text-weight-bold has-text-left">
            <div className="header-detail-item">
              <strong className="has-text-white">
                {" "}
                {labels?.sessionId[lng_type]} :{" "}
              </strong>{" "}
              <span className="has-text-warning">{_data?.session_label}</span>
            </div>
            <div className="header-detail-item">
              <strong className="has-text-white">
                {" "}
                {labels?.projectName[lng_type]} :{" "}
              </strong>{" "}
              <span className="has-text-warning">{_data?.project_name}</span>
            </div>
          </div>
        </div>
        <div className="timer-view">
          <div
            className={`timer  has-text-white ${
              timeLeft <= 5 * 60 ? "has-background-danger" : ""
            }`}
          >
            <div className="timer-icon">
              <i className="fa fa-clock is-size-4" aria-hidden="true"></i>{" "}
            </div>

            <div className="">
              <div className="is-size-7"> Time Remaining</div>
              <div>
                {startTime
                  ? Math.floor(timeLeft / 60) +
                    ":" +
                    String(timeLeft % 60).padStart(2, "0")
                  : "0"}
              </div>
            </div>
          </div>
          <div className="timer-date has-text-white is-size-7 has-text-centred">
            {labels?.date[lng_type]}:{" "}
            <span>
              {_data?.session_date
                ? moment(_data.session_date).format("DD-MM-YYYY")
                : ""}
            </span>
          </div>
        </div>
      </div>

      <div className="section pt-4">
        <div className="columns is-multiline">
          <div className="column is-4 question-nav px-0  card">
            <div className="questions-navigator pt-1">
              <div className="has-text-white  mb-1 title">
                {labels.questionNavigator[lng_type]}
              </div>
              <div className=" has-text-light is-size-7">
                {" "}
                {labels?.questions[lng_type]}:{questions?.length}
              </div>
            </div>
            <div className="columns is-multiline p-3">
              <div className="column is-12 ">
                <div className="buttons  is-flex is-flex-wrap-wrap is-justify-content-space-evenly">
                  {questions &&
                    questions?.length > 0 &&
                    questions.map((q, index) => (
                      <button
                        key={q.question_id}
                        className={`button  is-small  smart-q-button ${getButtonClass(
                          q,
                          index
                        )}`}
                        onClick={() => handleQuestionChange(index)}
                      >
                        {index + 1}
                      </button>
                    ))}
                </div>
              </div>
              <div className="column is-12">
                {/* Progress Bar */}
                <progress
                  className="progress is-primary is-small mb-2"
                  value={progressPercent}
                  max="100"
                >
                  {labels?.progress[lng_type]}
                </progress>

                <p className="is-size-7 has-text-grey mb-4">
                  ✅ {labels?.answered[lng_type]}: {answeredCount} /{" "}
                  {totalQuestions} ({progressPercent}%)
                </p>
                {/* Exam Statistics */}
                <div className="box has-background-light p-4 mb-4 smart-statistics-box">
                  <p className="is-size-6 mb-2">
                    📊 <strong>{labels?.examStatistics[lng_type]}</strong>
                  </p>
                  <p className="tag is-success is-light mb-1">
                    ✔ {labels?.answered[lng_type]}: {answeredCount}{" "}
                    {labels?.questions[lng_type]}
                  </p>
                  <p className="tag is-danger is-light mb-1">
                    ✘ {labels?.notAnswered[lng_type]}: {notAnsweredCount}{" "}
                    {labels?.questions[lng_type]}
                  </p>

                  <p className="tag is-dark is-light ">
                    ◻{labels.notVisited[lng_type]}{" "}
                    {
                      questions.filter(
                        (q) => !visitedQuestions.includes(q.question_id)
                      ).length
                    }{" "}
                    {labels?.questions[lng_type]}
                  </p>
                </div>

                {/* Color Legend */}
                <div className="box p-4 smart-legend-box">
                  <p className="is-size-6 mb-3">
                    🎨 <strong>{labels?.colorLegend[lng_type]}</strong>
                  </p>

                  <div className="is-flex">
                    <div className="smart-color-box smart-color-box--green"></div>
                    <div>{labels?.answered[lng_type]}</div>
                  </div>
                  <div className="is-flex">
                    <div className="smart-color-box smart-color-box--red"></div>
                    <div>{labels.notAnswered[lng_type]}</div>
                  </div>
                  <div className="is-flex">
                    <div className="smart-color-box smart-color-box--black "></div>
                    <div>{labels.notVisited[lng_type]}</div>
                  </div>
                  <div className="is-flex">
                    <div className="smart-color-box smart-color-box--blue"></div>
                    <div>{labels.currentQuestion[lng_type]}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <motion.div
            className="column is-8   "
            key={currentIndex}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.3 }}
          >
            <div className="questions-navigator py-3 px-4 has-text-white title is-flex is-justify-content-space-between">
              <div>
                {labels.questions[lng_type]} {currentIndex + 1} of{" "}
                {questions.length}
              </div>
              <div>
              <div className="field">
  <input
    id="langSwitch"
    type="checkbox"
    className="switch is-rounded is-info"
    checked={changeLang}
    onChange={toggleLangForCurrent}
  />
  <label htmlFor="langSwitch">{_data?.language_code === "hi" ? "English" : "Hindi"}</label>
</div>
              </div>
            </div>

            {questions && questions.length > 0 && (
              <div className="">
                {/* <header className="card-header">
                  <p className="card-header-title is-size-4">
                    {currentIndex + 1} {")"}{" "}
                    {questions[currentIndex].question_text}
                  </p>
                </header> */}
                <header className="card-header">
                  <p className="card-header-title is-size-4">
                    {currentIndex + 1}){" "}
                    {changeLang === true
                      ? questionsO[currentIndex]?.question_text
                      : questions[currentIndex]?.question_text}
                  </p>
                  {/* Language Switcher aligned right */}
                
                </header>

                <div className="card-content">
                  <div className="content">
                    <div className="columns is-multiline">
                      <div className="column is-8">
                        {(changeLang === true
                          ? questionsO[currentIndex]?.options
                          : questions[currentIndex]?.options
                        )?.map((option: any, idx: number) => (
                          <motion.p
                            key={idx}
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3, delay: idx * 0.2 }}
                          >
                            <label
                              className={`radio block p-2 mb-2 rounded ${
                                answers[questions[currentIndex].question_id] ===
                                option.option_id
                                  ? "selected-answer"
                                  : ""
                              }`}
                            >
                              <input
                                type="radio"
                                name={`question-${questions[currentIndex].question_id}`}
                                value={option.option_id}
                                checked={
                                  answers[
                                    questions[currentIndex].question_id
                                  ] === option.option_id
                                }
                                onChange={() =>
                                  handleOptionChange(
                                    questions[currentIndex].question_id,
                                    option.option_id
                                  )
                                }
                              />{" "}
                              <strong>{String.fromCharCode(65 + idx)})</strong>{" "}
                              {option.option_text}
                            </label>
                          </motion.p>
                        ))}
                      </div>

                      <div className="column is-4">
                        {questions[currentIndex].question_image &&
                          (() => {
                            const imageData = JSON.parse(
                              questions[currentIndex].question_image || "{}"
                            );
                            const imageContent = imageData?.content;

                            return imageContent ? (
                              <figure
                                className="image smart-exam-image"
                                onClick={() => {
                                  openImageModal(imageContent);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <motion.img
                                  src={`data:image/png;base64,${imageContent}`}
                                  alt="Question"
                                  className="has-border"
                                  initial={{ opacity: 0, scale: 0.8 }}
                                  animate={{ opacity: 1, scale: 1 }}
                                  transition={{ duration: 0.5 }}
                                />
                              </figure>
                            ) : null;
                          })()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Navigation Buttons */}
            <footer className=" smart-exam-footer">
              <div className="is-flex is-justify-content-space-between">
                <motion.button
                  className="button exam-primary-button"
                  onClick={() => setCurrentIndex(currentIndex - 1)}
                  disabled={currentIndex === 0}
                  // whileHover={{ scale: 1.1 }}
                  // whileTap={{ scale: 0.9 }}
                >
                  ⬅ Previous/पिछला
                </motion.button>
                <motion.button
                  className="button exam-primary-button"
                  onClick={() => setCurrentIndex(currentIndex + 1)}
                  disabled={currentIndex === questions.length - 1}
                  // whileHover={{ scale: 1.1 }}
                  // whileTap={{ scale: 0.9 }}
                >
                  Next/ अगला ➡
                </motion.button>
                <motion.button
                  className="button  is-danger"
                  onClick={() => {
                    const updatedAnswers = { ...answers };
                    delete updatedAnswers[questions[currentIndex].question_id];
                    setAnswers(updatedAnswers);
                  }}
                >
                  Clear Response / उत्तर मिटाएँ
                </motion.button>

                <motion.button
                  className="button is-success"
                  onClick={openStatus}
                  // whileHover={{ scale: 1.1, rotate: 3 }}
                  // whileTap={{ scale: 0.9 }}
                >
                  🏁 Finish Test / परीक्षा समाप्त करें
                </motion.button>
              </div>
            </footer>
            {/* <div className="columns">
            <div className="column is-6">
              <motion.button
                className="button is-link"
                onClick={() => setCurrentIndex(currentIndex - 1)}
                disabled={currentIndex === 0}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                ⬅ Previous/पिछला
              </motion.button>
            </div>

            <div className="column is-6 has-text-right">
              <motion.button
                className="button is-link mr-5"
                onClick={() => setCurrentIndex(currentIndex + 1)}
                disabled={currentIndex === questions.length - 1}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                Next/अगला ➡
              </motion.button>

              <motion.button
                className="button is-danger"
                onClick={openStatus}
                whileHover={{ scale: 1.1, rotate: 3 }}
                whileTap={{ scale: 0.9 }}
              >
                🏁 Finish Test/परीक्षा समाप्त करें
              </motion.button>
            </div>
          </div> */}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Exam;
